const GALLERY_TYPE = "wix-draft-plugin-gallery";
export {
  GALLERY_TYPE
};
//# sourceMappingURL=types.js.map
